import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourseEssence } from 'src/app/models/course-essence';
import { CourseKey } from 'src/app/models/course-key';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourseEssenceService {

  constructor(private http: HttpClient) { }

  getCourseEssenceDetail(id: number): Observable<CourseEssence> {
    return this.http.get<CourseEssence>(`${environment.apiUrl}/course/id/${id}`);
  }

  createCourseEssence(courseKey: CourseKey): Observable<number> {
    return this.http.post<number>(`${environment.apiUrl}/course-essences/`, courseKey);
  }

}